import {DG_axios} from "../../../custom/axios";
import {DG_axiosNormal} from "../../../custom/axios/normal";

const BASE_PATH = "/dogoo/files-manager-rest/v2.0/document-managers"
const FILE_BASE_PATH = "/dogoo/files-manager-rest/v2.0/files"

export async function createFolder(document) {

    const response = await DG_axiosNormal.post(BASE_PATH + `/folder`, document)

    return response?.data || []
}

export async function uploadFolder(data, onUploadProgress) {

    const response = await DG_axiosNormal.post(
        BASE_PATH + "/folder/upload",
        data,
        {headers: {"Content-Type": "multipart/form-data"}, onUploadProgress: onUploadProgress})

    return response?.data || []
}

export async function postDocumentAttach(attachedDocument) {

    const response = await DG_axiosNormal.post(BASE_PATH + "/attach", attachedDocument)

    return response?.data || []
}

export async function postMultipleFiles(data, onUploadProgress) {

    const response = await DG_axiosNormal.post(
        BASE_PATH + "/file",
        data,
        {headers: {"Content-Type": "multipart/form-data"}, onUploadProgress: onUploadProgress})

    return response?.data || []
}


export async function deleteDocumentById(id) {

    const response = await DG_axiosNormal.delete(BASE_PATH + `/${id}`)

    return response?.data || []
}

export async function createFavouriteFile(data) {

    const response = await DG_axiosNormal.post(BASE_PATH + "/favourites", data)

    return response?.data || []
}

export async function getDocumentById(id, category, pkCode, moduleId, appId, fullPath) {

    const response = await DG_axios.get(BASE_PATH + `/${id}`, {params: {category, pkCode, moduleId, appId, fullPath}})

    return response?.data || []
}

export async function renameDocument(id, data) {

    const response = await DG_axiosNormal.put(BASE_PATH + `/${id}/by-name`, data)

    return response?.data || []
}



export async function downloadDocumentById(id) {

    const config = {
        responseType: 'blob',
        headers: {
            'Content-Type': 'application/octet-stream',
        }
    }

    const response = await DG_axiosNormal.get(
        BASE_PATH + `/${id}/preview`, config
    );
    return response.data || []
}

export async function deleteDocumentByPkCode(pkCode) {

    const response = await DG_axiosNormal.delete(BASE_PATH + `/delete-parent/${pkCode}`)

    return response?.data || []
}

export async function getDocumentByPkCode(params) {

    const response = await DG_axios.get(BASE_PATH, {params})

    return response?.data || []
}

export async function getProjectDocumentByPkCode(params) {

    const response = await DG_axios.get(BASE_PATH + "/attach/project", {params})

    return response?.data || []
}

export async function postFile(data) {

    const response = await DG_axiosNormal.post(
        BASE_PATH + "/file",
        data,
        {headers: {"Content-Type": "multipart/form-data"}})

    return response?.data || []
}
